import { parseQuery, get7moorParams } from '@utils/utils'
import { platform,PLATFORM } from '@utils/device/platform'

const searchParams = new URLSearchParams(location.search)
const urlQuery = parseQuery()

/**
 * @description 读取token 根据不同环境获取token
 */
 export const readAccessToken = () => {
  let result
  switch (platform) {
    case PLATFORM.WXAPP:
      return searchParams.get('token') || urlQuery.token || localStorage.getItem('token') || ''
    case PLATFORM.APP:
      // eslint-disable-next-line
      // const appUserInfo = mfBridge.getAppUserInfo()
      // result = appUserInfo && JSON.parse(appUserInfo)
      return searchParams.get('token') || urlQuery.token || ''
    case PLATFORM.WEB:
      return (
        isSpecialUrl() ? getSpecialToken() :
        urlQuery.token ||
        localStorage.getItem('token') ||
        ''
      );
    case PLATFORM.WECHAT:
    default: // web && default
      return localStorage.getItem('token') || ''
  }
}
export const isSpecialUrl = () => { 
  return location.href.indexOf('customer-order-list') > -1 || location.href.indexOf('customer-order-detail') > -1
}
export const getSpecialToken = () => {
  const custom = get7moorParams('custom')
  return custom.token || ''
}
/**
 *
 * @param { String } accessToken
 * @description 将accessToken 写入本地localStorage中
 */
 export const writeAccessToken = (accessToken:any) => {
  return localStorage.setItem('token', accessToken)
}








